import { Outlet, Route } from 'react-router-dom';
import Journal from '../pages/Organization/public/Journal';
import AuthorSubmissionFormDataProvider from '../contexts/SubmissionContextProvider';
import { FormProvider } from '../contexts/FormContext';
import NavbarDashboard from 'src/components/NavbarDashboard';

const JournalRoutes = (
  <Route
    path="j/:ctxId"
    element={
      <>
        <NavbarDashboard />
        <Outlet />
      </>
    }
  >
    <Route
      index
      element={
        <FormProvider>
          <AuthorSubmissionFormDataProvider>
            <Journal />
          </AuthorSubmissionFormDataProvider>
        </FormProvider>
      }
    />
  </Route>
);

export default JournalRoutes;
